export const subtitles = {
    "1": {
        "startTime": 1.13,
        "endTime": 8.63,
        "transcript": "Yuut elpeci maavet upagallerci nutaan qanrutkeqerru Atmaulluarmun.",
        "translation": "Please start talking about how people, you, moved here to Atmautluak again."
    },
    "2": {
        "startTime": 8.63,
        "endTime": 12.52,
        "transcript": "Qangvaq-llu allrakumi maavet nugtartellruceci?",
        "translation": "And when, what year, did you move here?"
    },
    "3": {
        "startTime": 12.59,
        "endTime": 23.16,
        "transcript": "Yaa, ukut-wa tua-i ciumek 1969-aami nugtartellruut maavet Atmaulluarmun.",
        "translation": "Yes, these ones first moved here to Atmautluak in 1969."
    },
    "4": {
        "startTime": 23.16,
        "endTime": 33.88,
        "transcript": "Tua-i-ll' wiinga allrakumi ataucimi tayim' '71-aami maavet nugtarrlua.",
        "translation": "Then in one year in '71, I moved here."
    },
    "5": {
        "startTime": 34.387,
        "endTime": 48.342,
        "transcript": "Tua-i yuk, yuk-wa tua-i neqelgem-wa tua-i, wangkuta Yugni neqelgem tau͡gaam nuniinun pituamta ukanirpak avaken.",
        "translation": "A person, it's because a person, we Yupiit, historically only to places where there is fish since a long time ago."
    },
    "6": {
        "startTime": 48.36,
        "endTime": 52.94,
        "transcript": "Ciuliamteńek-wa tua-i ayagluta neqnek nertuamta.",
        "translation": "It's because we've always eaten fish starting from our ancestors."
    },
    "7": {
        "startTime": 54.175,
        "endTime": 60.005,
        "transcript": "Nervikluku man'a wani, nervigkaqluku upagallrulliniut.",
        "translation": "So they moved to get food from here."
    },
    "8": {
        "startTime": 60.015,
        "endTime": 61.065,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "9": {
        "startTime": 61.695,
        "endTime": 72.155,
        "transcript": "Yaa, tua-i, tua-i tayima-llu upallrunrilkumta ikegkut Nunapicuarmiut watuam nalliini piviicartut.",
        "translation": "Yes, had we not moved, the people of Nunpitchuk across there would have nowhere to be now."
    },
    "10": {
        "startTime": 76.88,
        "endTime": 82.64,
        "transcript": "Tayima wangkuta ceńami uitalartukut.",
        "translation": "We live on the coast."
    },
    "11": {
        "startTime": 82.645,
        "endTime": 88.115,
        "transcript": "Ceńami-llu tayima yuilqumun ayalriit alerquukarangqelartut",
        "translation": "And on the coast, those who go to the wilderness have traditional instructions"
    },
    "12": {
        "startTime": 88.125,
        "endTime": 92.735,
        "transcript": "Wall'u imarpigmun aya'agqameng imarpigmi alerquukararluteng.",
        "translation": "Or when they go to the ocean, they have traditional instructions in the ocean."
    },
    "13": {
        "startTime": 92.754,
        "endTime": 106.899,
        "transcript": "Qaillun maani tua-i-w' yuilquqvani elpeci anglillerpeni maani qaillun ciuliarpet alerqualallruatgen ayagayaurtellerpeni?",
        "translation": "How, here as you grew up here deep in the wilderness, how did your elders instruct you when you started traveling?"
    },
    "14": {
        "startTime": 108.261,
        "endTime": 113.894,
        "transcript": "Aknirtenritlerkan wall'u qaill' tua-i pinritlerkarpenun alerqualallruatgen?",
        "translation": "How did they instruct you so you wouldn't get hurt, or so nothing would happen to you?"
    },
    "15": {
        "startTime": 113.902,
        "endTime": 125.042,
        "transcript": "Alerquutengqellruukut imumi ayagyuarluta arcaqerluku qanikciurun wall'u cikuliurun, ayaruq.",
        "translation": "We had traditinional instruction back when we were young, especially [to take] a shovel or ice pick, a walking staff."
    },
    "16": {
        "startTime": 125.127,
        "endTime": 131.587,
        "transcript": "Ayaruq-llu tamana qanrutketullruat unguvauniluku yugmun.",
        "translation": "They also talked about that staff, saying it is life for a person."
    },
    "17": {
        "startTime": 131.882,
        "endTime": 139.402,
        "transcript": "Cali-llu waniw' ukut arcaqerluki alerquutektullrit:",
        "translation": "These are also the important things they instructed:"
    },
    "18": {
        "startTime": 140.557,
        "endTime": 153.627,
        "transcript": "Tua-i-w' imarnitet wangkuta Yugcetun au͡gkut avani makunek Kass'artartnek pingvailegmeng tamakut tua-i tamaa-i imarnitet atutullrulliniit.",
        "translation": "Those seal gut rain parkas, we Yupiit, back before these Western things came, they used to use those seal gut rain parkas."
    },
    "19": {
        "startTime": 154.417,
        "endTime": 159.637,
        "transcript": "Tua-i-llu wangkuta Kass'angumariluku maa-i yuurtellriani",
        "translation": "Then for us who were born after Caucasians had come"
    },
    "20": {
        "startTime": 159.822,
        "endTime": 172.282,
        "transcript": "Angayuqamta alerqutullruitkut tua-i tamakut tua-i tamaa-i ellalliurcuutet arcaqerluki qelkesqelluki wangkutnun ella assirngalengraan.",
        "translation": "Our parents used to instruct us to especially keep those rainproof clothes with us even if the weather seems good."
    },
    "21": {
        "startTime": 174.357,
        "endTime": 181.827,
        "transcript": "Tua-i iliini waten iquklicuilan ella up'nerkami wall'u uksuarmi",
        "translation": "Because sometimes, the weather doesn't relent like this in the spring or fall"
    },
    "22": {
        "startTime": 181.927,
        "endTime": 192.037,
        "transcript": "Tua-i taukut tua-i tamaa-i arcaqerluki wangkutnun avaliqesqelluki pitullruit.",
        "translation": "Those were the things that they especially told us to have with us."
    },
    "23": {
        "startTime": 192.137,
        "endTime": 201.157,
        "transcript": "Tua-i ayarumek piilkumta tua-i qaillun nalluciqngamteggu-wa tua-i cam-llu aarnarqucia nalluluku.",
        "translation": "Because if we don't have a staff, we won't know things, and we won't know that something is dangerous."
    },
    "24": {
        "startTime": 201.642,
        "endTime": 212.982,
        "transcript": "Wall'u uksumi ayagaqamta qanikciurun ucikerrlainarluku cali ella assingraan pisqelluta.",
        "translation": "Or, they also told us that when we travel in the winter, to always have a shovel in our cargo even if the weather is good."
    },
    "25": {
        "startTime": 213.547,
        "endTime": 224.087,
        "transcript": "Arenqiallugeskumta cunawa yuilqumi wall'u pirtunguskakut, ellaqerruskakut tua-i cali alerquutekluku",
        "translation": "If we get into misfortune, it turns out, in the wilderness, or if a blizzard his us, or the weather changes on us, they also instructed"
    },
    "26": {
        "startTime": 224.632,
        "endTime": 230.542,
        "transcript": "Agnermun, agellranun-wa tua-i arulairesqevkenata.",
        "translation": "They told us not to stop at a small snowbank."
    },
    "27": {
        "startTime": 230.742,
        "endTime": 238.392,
        "transcript": "Tau͡gaam-llu tua-i camek kangiciramek-llu piilkumta qanikciurutengqerqumta",
        "translation": "But also, if we have no tarpaulin, if we have a shovel"
    },
    "28": {
        "startTime": 238.512,
        "endTime": 244.782,
        "transcript": "Qengaruk, ak'a qengaruurtelleq tauna elagluku.",
        "translation": "A snowbank, dig into an already formed snowbank."
    },
    "29": {
        "startTime": 246.562,
        "endTime": 256.272,
        "transcript": "Iluani tua-i tuani uitasqelluta tau͡gaam cali muragmek kapsuutekaanek tauna piluku.",
        "translation": "They told us to stay inside of it, but to also get a piece of wood to poke [the ceiling]."
    },
    "30": {
        "startTime": 256.282,
        "endTime": 261.532,
        "transcript": "Kiiriaqan kapurluku elcetaqluku.",
        "translation": "When it gets hot, poke it to ventilate it."
    },
    "31": {
        "startTime": 261.882,
        "endTime": 272.552,
        "transcript": "Tua-i tamaa-i tamakut arcaqerluki wangkuta alerquutekellruaput au͡gkunun-wa tua-i ciuliamteńun.",
        "translation": "Those were our important traditional instruction from our elders."
    },
    "32": {
        "startTime": 273.478,
        "endTime": 288.344,
        "transcript": "Cali-llu tua-i-wa ayagyuamteńun makunun waniw' tua-i quyatekngamku alerquutekqeryuumiryaaqaqa cali atauciq.",
        "translation": "Also, since I am thankful for it, I want to give one quick traditional instruction to our youth."
    },
    "33": {
        "startTime": 289.301,
        "endTime": 298.038,
        "transcript": "Tua-i cali wii aipangqerraallemni, tua-i-w' aipanglua",
        "translation": "Also, when I got married, when I got married"
    },
    "34": {
        "startTime": 298.144,
        "endTime": 308.29,
        "transcript": "Wall' irnianglua-llu atama au͡g'um mulngakevkenii qanrutetullruamia tua-i tamaa-i tamaani",
        "translation": "Or when I also had children, since my father wouldn't hold back when advising me back then"
    },
    "35": {
        "startTime": 308.623,
        "endTime": 315.778,
        "transcript": "Qalarut'lallruanga waten: mikelnguq irniangekumegnuk pitsaqevkenanuk",
        "translation": "He used to speak to me like this: a child, should we have children"
    },
    "36": {
        "startTime": 316.357,
        "endTime": 327.821,
        "transcript": "Qialuni itengraan apqauresqevkenaku wall'u qaillun picianek kitumun-llu picianek aptesqev[kenaku].",
        "translation": "Even if [s]he comes in crying that we shouldn't as questions, or ask what's wrong or who did it."
    },
    "37": {
        "startTime": 327.834,
        "endTime": 331.507,
        "transcript": "Tua-i-wa eyurnakluku pisqevkenaku.",
        "translation": "He said not to be defensive over them."
    },
    "38": {
        "startTime": 331.951,
        "endTime": 340.741,
        "transcript": "Atam-gguq eyurnakluku pilaqumegnegu taum mikelngucuaraam ukvercugngariniaraakuk.",
        "translation": "Watch, he said, if we defend them, that little child will be able to make us believe [anything]."
    },
    "39": {
        "startTime": 340.746,
        "endTime": 347.019,
        "transcript": "Ayainanmegni yugnikek'ngamegnun umyuarpuk assiicecugngarivkarluku.",
        "translation": "As we go, [s]he can make us upset with our friends."
    },
    "40": {
        "startTime": 347.968,
        "endTime": 354.922,
        "transcript": "Tua-i-llu cali pinarikuni cali maa-i-llu elitnaungelriit",
        "translation": "Then when it's time for him, since they've also started going to school"
    },
    "41": {
        "startTime": 355.903,
        "endTime": 360.994,
        "transcript": "Inerqulangraatni-gguq yuut niicuiciiquq.",
        "translation": "He said that even if people admonish them, [s]he will not obey."
    },
    "42": {
        "startTime": 361.004,
        "endTime": 365.495,
        "transcript": "Tua-i-gguq-wa wangkugnek eyurtekangqerrami.",
        "translation": "He said it's because [s]he has us to defend them."
    },
    "43": {
        "startTime": 366.757,
        "endTime": 377.329,
        "transcript": "Tua-i tamaa-i tamana arcaqerluku qanrutkeqeryuumiamku quyatekngamku tua-i taiqallertek qanrutkartaqa.",
        "translation": "Since I especially yearned to say that because I'm thankful that you came, I spoke about it."
    },
    "44": {
        "startTime": 380.045,
        "endTime": 387.836,
        "transcript": "Maa-i, maa-i cali kit'ellriit, kit'ellriit kiagmi amlleringut.",
        "translation": "Now, those who drown, there are now a lot who drown in the summer."
    },
    "45": {
        "startTime": 387.839,
        "endTime": 398.748,
        "transcript": "Ciungani-mi tua-i... amllerrniluki, niitaqlua-llu kanvelriatun maa-i ernemteńi ayuqniluta kuigkun.",
        "translation": "What about in the past... they say there's a lot, and I hear that it's like we're dying in great numbesr in our day through the river."
    },
    "46": {
        "startTime": 400.157,
        "endTime": 412.503,
        "transcript": "Qaillun cali ayagatuli tan'gaurluut wall'u tayima allat-llu alerquayugngasiki tuatnanritlerkaatnek?",
        "translation": "What can you instruct those who travel, boys or others, so that they wouldn't do that?"
    },
    "47": {
        "startTime": 412.721,
        "endTime": 423.948,
        "transcript": "Yaa, mat'umun-wa tua͡gaam qanrutkelallratnun arcaqerluku tua-i maa-i mat'umek piitqapigtellrunricaaqut.",
        "translation": "Yes, especially what they said about this, they weren't actually completely without it."
    },
    "48": {
        "startTime": 423.96,
        "endTime": 429.542,
        "transcript": "Wangkuta imumi yuurtellemteńi Kass'angumariluku yuurtellruamta",
        "translation": "Back when we were born, because we were born when there'd been Caucasians"
    },
    "49": {
        "startTime": 429.554,
        "endTime": 435.172,
        "transcript": "Tau͡gaam makunek massiinangellrata-llu cukalrianek",
        "translation": "But having gotten these fast boat motors"
    },
    "50": {
        "startTime": 435.173,
        "endTime": 447.464,
        "transcript": "Tamaa-i tamatum arcaqerluki, ayagassuutetgun-wa tua-i makugtun pingellrata arcaqerluki yuut kanvelriacetun pingevkarait.",
        "translation": "Those especially, starting to use these vehicles especially is what's causing people to die in great numbers."
    },
    "51": {
        "startTime": 447.479,
        "endTime": 456.243,
        "transcript": "Cali-ll' mat'umek usviitnarqellriamek tamaa-i atullrata tuaten pivkallii.",
        "translation": "And abusing this mind-altering substance is probably what's making do that."
    },
    "52": {
        "startTime": 456.453,
        "endTime": 464.803,
        "transcript": "Imumi tua-i nallemni-llu wii Mamterillerni kanani kipusviit-llu tamarmeng taangiviullruyaaqut.",
        "translation": "Long ago, and in my time, all of the stores down in Bethel were all liquor stores."
    },
    "53": {
        "startTime": 464.813,
        "endTime": 476.268,
        "transcript": "Tau͡gaam elluatumek ayagassuutaitellruameng tamaani tuaten tua-i pilange'rmeng nallunallruut.",
        "translation": "But since they didn't have sophisticated vehicles back then, though they [drank] like that, they didn't know [of people dying a lot]."
    },
    "54": {
        "startTime": 477.366,
        "endTime": 487.126,
        "transcript": "Tua-i maa-i alerqualaryaaqaput makut irniaput, tua-i wiinga-ll' ukut irnianka tua-i qalarutaqluki",
        "translation": "Now, we do instruct our children, and I also advise my children"
    },
    "55": {
        "startTime": 487.133,
        "endTime": 493.121,
        "transcript": "Tau͡gaam watuam nalliini tuacetun, wiinga-llu angayuqamtun",
        "translation": "But these days like that, and me, like my parents"
    },
    "56": {
        "startTime": 494.225,
        "endTime": 498.98,
        "transcript": "Tua-i-wa unisteka au͡gna tangvallruyaaqaqa wangnek-llu",
        "translation": "I used to watch my late father and myself"
    },
    "57": {
        "startTime": 498.989,
        "endTime": 505.58,
        "transcript": "Tau͡gaam tuacetuqapiar maa-i pisciigatanka elliitun.",
        "translation": "But I cannot [instruct] them exactly like he did."
    },
    "58": {
        "startTime": 506.864,
        "endTime": 516.555,
        "transcript": "Tua-i-wa cangayullerkaat wiinga pitekluku wall'u iqlutmuqertellerkaat pitekluku piyaaqellrianga. Cunaw' wiinga alarrlua.",
        "translation": "I did that because they may feel offended or may go in the wrong direction. It turned out I made a mistake."
    },
    "59": {
        "startTime": 517.593,
        "endTime": 528.462,
        "transcript": "Yaa, tua-i kenkekumki waten aarnarqellria tamalkuan mulngakevkenaki tua-i qalarutarkauyaaqellinianka",
        "translation": "Yes, if I love them, I must not hold back speaking about everything dangerous like this"
    },
    "60": {
        "startTime": 528.468,
        "endTime": 532.159,
        "transcript": "Tua-i umyuaqellarkaat tau͡gaam ellaita pitekluku.",
        "translation": "So that they will remember them."
    },
    "61": {
        "startTime": 532.488,
        "endTime": 535.279,
        "transcript": "Tua-i maa-i amllermi nallunri...",
        "translation": "Now, [unspecified] know[s] many times..."
    },
    "62": {
        "startTime": 535.289,
        "endTime": 544.961,
        "transcript": "Tua-i-wa waten angayuqameggnek saagilriit elluarrluteng yuuyuitelliniut.",
        "translation": "Those who [?break apart] their parents evidently do not live well."
    },
    "63": {
        "startTime": 544.967,
        "endTime": 553.995,
        "transcript": "Cali-llu qanruyuteteng atunrilkait ellaita tua-i waten tua-i cailkamun ellilriacetun ayuqaqluteng.",
        "translation": "Also, those who don't follow the traditional wisdom passed down to them like this, are like those who've ended up on the ground."
    },
    "64": {
        "startTime": 554.645,
        "endTime": 559.8,
        "transcript": "Cali-llu niitessaanrilnge'rmi nunanek allanek",
        "translation": "Also, though [s]he tried not to be heard of in other villages"
    },
    "65": {
        "startTime": 560.923,
        "endTime": 568.204,
        "transcript": "Napartem kangrani arulalriacetun tauna yuk ayuqaqluni qanruyutni atunritaqamiu.",
        "translation": "That person is like something waving on top of a pole when [s]he doesn't follow their traditional wisdom."
    },
    "66": {
        "startTime": 568.971,
        "endTime": 578.007,
        "transcript": "Tau͡gken imna qanruyutmi aturtii catailngurcetun, nunaqliq'ng'e'rmi-llu maani catailngurcetun ayuqluni.",
        "translation": "However, one who follows their traditional wisdom seems absent, and they seem absent even here in neighboring villages."
    },
    "67": {
        "startTime": 579.457,
        "endTime": 587.148,
        "transcript": "Nangnermek, tayima qaillun elpet Fred Pavilla",
        "translation": "Lastly, how would you, Fred Pavilla"
    },
    "68": {
        "startTime": 588.788,
        "endTime": 596.633,
        "transcript": "Camek arcaqalriamek paitarkicukengavnek",
        "translation": "Something important that you want to leave the next generations"
    },
    "69": {
        "startTime": 596.645,
        "endTime": 607.999,
        "transcript": "Elpeni tua-i camek wangkuta pitsaqa'artevkenata tayima kinguvni anerteqkumta, anerteqellriani, anerteqarkani",
        "translation": "What would you [pass on] to us, should we, by happenstance, live after you, who do live, who will live"
    },
    "70": {
        "startTime": 608.008,
        "endTime": 613.035,
        "transcript": "Qaillun alerquayugngasikut? Camek paitarkicugngasikut elpet?",
        "translation": "How can you instruct us? What can you leave with us?"
    },
    "71": {
        "startTime": 613.132,
        "endTime": 617.432,
        "transcript": "Wiinga paitarkicugngaamci ayagyuani",
        "translation": "I can leave with you young people"
    },
    "72": {
        "startTime": 617.662,
        "endTime": 625.515,
        "transcript": "Waten-wa tua-i yuk qaillun ayuqengraan, assiilengraan ilaliurluku",
        "translation": "Like this, no matter what a person is like, even if they're bad, socialize with them"
    },
    "73": {
        "startTime": 625.523,
        "endTime": 633.905,
        "transcript": "Wall'u pikailkuvci tua-i tuaten tua-i qanrrarpeciuggun, wall'u pikangqerquvci nerevkarluku.",
        "translation": "Or if you have none, offer a small conversation like that, or if you have some, feed them."
    },
    "74": {
        "startTime": 635.39,
        "endTime": 643.826,
        "transcript": "Qaillun-wa tua-i yuk ayuqengraan, ayuqngalengraan tamamta yugni assiilamta maani nunam qaingani.",
        "translation": "It's because no matter what a person is like, what they seem like, all of us people are faulty here on this earth."
    },
    "75": {
        "startTime": 645.129,
        "endTime": 657.364,
        "transcript": "Tua-i-gguq tamaa-i tau͡gaam tuaten ayuqellria yuk pitsaqa'artevkenani-llu arenqiallugtaqami ikayurtaicuituq.",
        "translation": "They said that a person who is [nice] like that is never without help should they get into misfortune."
    },
    "76": {
        "startTime": 657.671,
        "endTime": 659.816,
        "transcript": "Tuaten ayuqellria.",
        "translation": "A [nice] person like that."
    },
    "77": {
        "startTime": 660.017,
        "endTime": 668.971,
        "transcript": "Cali-llu tua-i-wa tangllerkaa, qaillun qanrutkellerkaa",
        "translation": "Also, how [s]he would be seen, how [s]he would be talked about"
    },
    "78": {
        "startTime": 669.386,
        "endTime": 673.005,
        "transcript": "Tua-i-w' tangllerkaa tengrunaqluni-gguq.",
        "translation": "They say people are excited to see them."
    },
    "79": {
        "startTime": 673.183,
        "endTime": 678.092,
        "transcript": "Tuaten tua-i, wall'u ikayullerkaa tengrunaqluni.",
        "translation": "Like that, or people are excited to help them."
    },
    "80": {
        "startTime": 678.393,
        "endTime": 686.738,
        "transcript": "Tuaten ilaliuqtarluni yuulria, tua-i-w' tangerqeńi tamalkuan kenekluku yuulria.",
        "translation": "One who lives socializing like that, one who lives treating everyone they see with love."
    },
    "81": {
        "startTime": 687.325,
        "endTime": 695.87,
        "transcript": "Tamaa-i tua-i tamana arcaqerluku wii alerquutekellruaqa au͡gkunun angayuqaagemnun.",
        "translation": "That was my most important traditional instruction from my parents."
    },
    "82": {
        "startTime": 696.088,
        "endTime": 706.843,
        "transcript": "Qaillun ayuqellria, wall'u elliraulria, wall'u elliraunrilengraan ayuqluku yuk arenqiallugtellria wangnun ikayuusqelluku.",
        "translation": "No matter what one is like, or an orphan, or even if [s]he's not an orphan, they told me to help a person in misfortune all the same."
    },
    "83": {
        "startTime": 708.478,
        "endTime": 709.696,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "84": {
        "startTime": 710.485,
        "endTime": 711.485,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "85": {
        "startTime": 711.494,
        "endTime": 712.767,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "86": {
        "startTime": 717.979,
        "endTime": 721.743,
        "transcript": "Nasaurluut tayim' qanruyutengqelallruut.",
        "translation": "Girls had traditional wisdom specific to them."
    },
    "87": {
        "startTime": 723.381,
        "endTime": 733.57,
        "transcript": "Ca elpeni maa-i umyuaqenrusiu alerquutek'lalten imumi ayagyuapiallerpeni?",
        "translation": "What traditional instructions from back what you were very young do you most remember now?"
    },
    "88": {
        "startTime": 734.046,
        "endTime": 741.873,
        "transcript": "Alerquutek'lallrenka-wa arnani amllellriit.",
        "translation": "The traditional instruction I was given, there are many for women."
    },
    "89": {
        "startTime": 742.024,
        "endTime": 746.606,
        "transcript": "Cali tan'gaurluut allakarmeng, tuar allakarmeng.",
        "translation": "Boys also [had] separate ones, it seemed they were separate."
    },
    "90": {
        "startTime": 746.618,
        "endTime": 752.39,
        "transcript": "Allakarmeng pinrilnge'rmeng qanruyuterluteng.",
        "translation": "Even if they weren't separate, they had traditional wisdom specific to them."
    },
    "91": {
        "startTime": 752.745,
        "endTime": 759.418,
        "transcript": "Wiinga-ll' qanruyutellemnek alairluteng mat'um nalliini.",
        "translation": "And the traditional wisdom passed down to me have been revelead these days."
    },
    "92": {
        "startTime": 759.826,
        "endTime": 767.226,
        "transcript": "Maaten alairtut mat'um nalliini.",
        "translation": "Lo and behold, they were revealed these days."
    },
    "93": {
        "startTime": 767.41,
        "endTime": 774.67,
        "transcript": "Ellangellruunga wii makut anglluumariluta-llu, anglluumariluki.",
        "translation": "In my earliest memories, we were baptized, they'd been baptized."
    },
    "94": {
        "startTime": 774.71,
        "endTime": 782.99,
        "transcript": "Ellanglua kinguqvaarni-ll' maani taum angllurtekamta tekicakut angllurluta.",
        "translation": "I became aware, and later here, when our baptist came to us, we were baptized."
    },
    "95": {
        "startTime": 783.795,
        "endTime": 787.565,
        "transcript": "Wangni akaaraurtuq yuurtelqa.",
        "translation": "To me, it's been quite a while since I was born."
    },
    "96": {
        "startTime": 787.73,
        "endTime": 794.93,
        "transcript": "Tua-llu qanruyutengqellruukut",
        "translation": "Then, we were given traditional wisdom"
    },
    "97": {
        "startTime": 795.004,
        "endTime": 805.694,
        "transcript": "Atamta aanamta-llu qanvallagatenrilengraitkut, waten qanpagalluta pinrilengraitkut",
        "translation": "Even if our fathers and mothers don't harshly speak to us, even if they don't shout at us like this"
    },
    "98": {
        "startTime": 807.714,
        "endTime": 817.134,
        "transcript": "Alingnarqellriacetun ayuqluteng alingnaileng'e'rmeng callagaksaileng'e'rmegtekut-llu yagleraluta.",
        "translation": "It was like they were scary even if they weren't scary, even if they didn't harshly react to us, raising their hands against us."
    },
    "99": {
        "startTime": 819.313,
        "endTime": 830.616,
        "transcript": "Qanruyutengqellruukut arnani atakumi-llu tarritesqevkenata, ullagatesqevkenata-llu.",
        "translation": "We women had traditional wisdom saying not to wander in the evening, and not to have many visitors."
    },
    "100": {
        "startTime": 831.128,
        "endTime": 842.345,
        "transcript": "Una tua-i wii aanamnek arcaqerluku, aanamnek atamnek-llu waten:",
        "translation": "This was important from my mother, my mother and father, like this:"
    },
    "101": {
        "startTime": 842.491,
        "endTime": 848.721,
        "transcript": "Qalartellriik-gguq camek assiilngurmek niicugninrillakek.",
        "translation": "They said that I shouldn't listen to people speaking of something bad."
    },
    "102": {
        "startTime": 850.3,
        "endTime": 860.508,
        "transcript": "Tua-ll' qalarucilriamek tangerquma, qalarucilriamek tangerquma",
        "translation": "Then if I see someone giving instruction, if I see someone giving instruction"
    },
    "103": {
        "startTime": 862.242,
        "endTime": 870.482,
        "transcript": "Ullagluku nutaan niicugnisqelluku inerquutnek qalartellria.",
        "translation": "They said to go to and listen to one speaking of admonishments."
    },
    "104": {
        "startTime": 870.991,
        "endTime": 873.801,
        "transcript": "Tamaani nepaitellruut.",
        "translation": "They were peaceful back then."
    },
    "105": {
        "startTime": 873.813,
        "endTime": 880.253,
        "transcript": "Tau͡gaam Qaneryaram mat'um qanrutkellri makut wani",
        "translation": "But these things the Bible spoke about"
    },
    "106": {
        "startTime": 882.45,
        "endTime": 888.65,
        "transcript": "Qanrutkumalria tekirqerput, murilkelluci elpeci yuuci.",
        "translation": "As we're coming to what was foretold, you must live carefully."
    },
    "107": {
        "startTime": 889.954,
        "endTime": 892.674,
        "transcript": "Murilkengnaqluci.",
        "translation": "Try to be careful."
    },
    "108": {
        "startTime": 892.798,
        "endTime": 902.748,
        "transcript": "Una tekitaqan tangnerrarpek'naku elitaq'larnaurci, cangayung'erpeci-llu cangakevkenaku.",
        "translation": "So when this comes [to pass], you will not be surprised but recognize it, and even if you dislike it, you will not think it amiss."
    },
    "109": {
        "startTime": 905.039,
        "endTime": 918.059,
        "transcript": "Una-llu qanlerayulria angun wall'u arnaq, qastuluni qalarculria, tauna tua-i assikevkenaku.",
        "translation": "And this man or woman who tends to speak harshly, speak loudly, they don't like that."
    },
    "110": {
        "startTime": 920.901,
        "endTime": 932.531,
        "transcript": "Waten-llu tan'gaurluq ayagyuaq takuanun qanleralluku yugnek niitesterluni callallerkaa umyuaqevkenaku",
        "translation": "And harshly speaking to a young boy in his presence like this, with people listening, without regard for how he might suddenly react"
    },
    "111": {
        "startTime": 932.542,
        "endTime": 940.232,
        "transcript": "Tamaa-i tamana caniluku [tegg'anernaqniluku].",
        "translation": "They say that causes them to be a certain way [makes them hardened]."
    },
    "112": {
        "startTime": 941.549,
        "endTime": 955.14,
        "transcript": "Tua-i mat'um nalliini qanruyutvut man'a, eneqangluku-ll' wii caknengama tutgaramnek wall'u makunek yumnek.",
        "translation": "These days, our traditional wisdom, I'm starting to remember it since I'm starting to struggle with my grandchildren or my children."
    },
    "113": {
        "startTime": 955.155,
        "endTime": 958.305,
        "transcript": "Caknengama eneqangluku.",
        "translation": "Since I'm starting to struggle, I'm remembering it."
    },
    "114": {
        "startTime": 959.733,
        "endTime": 972.986,
        "transcript": "Qanpagayulria tauna, qastuluni qalarculria atawakevkenaku",
        "translation": "They do not think that person who shouts, speaks loudly, is good"
    },
    "115": {
        "startTime": 973.646,
        "endTime": 978.146,
        "transcript": "Wall'u makut qanruskengaarin piyugluku.",
        "translation": "Or those who react [badly] to those who instruct them."
    },
    "116": {
        "startTime": 981.425,
        "endTime": 991.135,
        "transcript": "Tua-i waniwa man'a tegg'anrutka elpeceńun ayagyuanun",
        "translation": "This is what I tell you young people to make you steadfast"
    },
    "117": {
        "startTime": 991.484,
        "endTime": 1001.724,
        "transcript": "Cali man'a tangrrinarpek'naku assinrilnguq waten qanqainaunrilmilria waten tayima wangkucicetun.",
        "translation": "Also, do not merely look at something bad, and one who doesn't merely need to be told like this like us."
    },
    "118": {
        "startTime": 1002.257,
        "endTime": 1008.937,
        "transcript": "Wangkuta-llu, wangkuta-llu niicuilmillruukut ilaitni.",
        "translation": "Us too, some of use were also disobedient."
    },
    "119": {
        "startTime": 1008.943,
        "endTime": 1018.813,
        "transcript": "Tamana tua-i aanamteńek kiirraramegnuk aanama imum qanrutetullrulua.",
        "translation": "From our mother, just the two of us, she would tell me that."
    },
    "120": {
        "startTime": 1019.23,
        "endTime": 1024.278,
        "transcript": "Cali-ll' uum nalliini nallunritliuci.",
        "translation": "Also, you may know these days."
    },
    "121": {
        "startTime": 1024.836,
        "endTime": 1035.716,
        "transcript": "Uum nalliini makut-llu, makuni tau͡gaam niitetuluku makuni agayuviit iluatni.",
        "translation": "These days, you only here it inside these churches."
    },
    "122": {
        "startTime": 1035.723,
        "endTime": 1048.622,
        "transcript": "Tau͡gaam tuaten cailkami-llu qanrutestairutlerpeci pillikiici.",
        "translation": "But, having no one to instruct you in random places like that has probably done that to you."
    },
    "123": {
        "startTime": 1050.513,
        "endTime": 1057.853,
        "transcript": "Man'a tua-i maa-i elli'irtun ayuquq qanqaunrilnguq sagtellria.",
        "translation": "One who doesn't need to merely be told and scatters is like an orphan."
    },
    "124": {
        "startTime": 1057.861,
        "endTime": 1061.481,
        "transcript": "Kiituani-ll' picurlallerkaminun tekituq.",
        "translation": "And eventually, [s]he comes to misfortune."
    },
    "125": {
        "startTime": 1063.098,
        "endTime": 1068.108,
        "transcript": "Ciulirnerpeceńi piniatelartukut iliini.",
        "translation": "We, your elders, are sometimes weak."
    },
    "126": {
        "startTime": 1069.209,
        "endTime": 1079.129,
        "transcript": "Makut ayagyuat inerqung'e'rmeng-llu inerquutseng katakiit tangerrluku.",
        "translation": "Though these young people are admonished, look, they drop their admonishments."
    },
    "127": {
        "startTime": 1079.514,
        "endTime": 1083.764,
        "transcript": "Tua-i waten eneqakellrenka waniwa amllertaut.",
        "translation": "This is as much as I remember."
    },
    "128": {
        "startTime": 1088.436,
        "endTime": 1097.887,
        "transcript": "Aipangqatallerpeni-mi, aipangqatallerpeni qaillun alerquumalallrusit aipaqucaram tungiinun?",
        "translation": "So, when you were going to get married, how were you instructed about how to be a spouse?"
    },
    "129": {
        "startTime": 1097.893,
        "endTime": 1103.413,
        "transcript": "Nutaan tuani qanrucimalua aipangqatallemni.",
        "translation": "I was finally instructed when I was going to get married."
    },
    "130": {
        "startTime": 1104.575,
        "endTime": 1112.015,
        "transcript": "Waniwa-ll' wii 13-aarpailegma-ll' waten talliirutellruunga nutlaglua.",
        "translation": "And before I was 13, I lost my arm like this to a misfire."
    },
    "131": {
        "startTime": 1113.581,
        "endTime": 1123.301,
        "transcript": "Tua-i-llu aipangllerkamnek neryuniurutevkenii. Cunaw' aanama imum auluklua.",
        "translation": "Then I wasn't expecting to get married. It turned out my mother took care of me."
    },
    "132": {
        "startTime": 1123.318,
        "endTime": 1127.688,
        "transcript": "Waten talliinii pingaicuklua yugmun.",
        "translation": "I didn't think I'd be with a person without an arm like this."
    },
    "133": {
        "startTime": 1128.159,
        "endTime": 1134.619,
        "transcript": "Tau͡gaam aipangqatallemni nutaan qalarutellruanga.",
        "translation": "But she finally instructed me when I was going to get married."
    },
    "134": {
        "startTime": 1135.235,
        "endTime": 1138.805,
        "transcript": "Ca tamalkuan piluku.",
        "translation": "She covered everything."
    },
    "135": {
        "startTime": 1139.244,
        "endTime": 1143.144,
        "transcript": "Tua-i-w' ca tamalkuan qalarutekluku.",
        "translation": "She talked about everything."
    },
    "136": {
        "startTime": 1144.942,
        "endTime": 1151.772,
        "transcript": "Aipamnek-llu waten kiulerallerkaqa inerquutet",
        "translation": "And the admonishments against harshly replying to my spouse like this"
    },
    "137": {
        "startTime": 1155.726,
        "endTime": 1157.536,
        "transcript": "Inerquutet",
        "translation": "The admonishments"
    },
    "138": {
        "startTime": 1157.616,
        "endTime": 1162.616,
        "transcript": "Tua-i-w' inerquutet nutaan wangnun piluki.",
        "translation": "She finally told me of the admonishments."
    },
    "139": {
        "startTime": 1163.589,
        "endTime": 1174.419,
        "transcript": "Caperrnaqluni. Caperrnaqluni qaill' tuaten piqallerkaa takuatni wall' takuqenrilengraatgu.",
        "translation": "It was daunting. It was daunting to do something like that in their presence, or even if wasn't in their presence."
    },
    "140": {
        "startTime": 1174.827,
        "endTime": 1179.977,
        "transcript": "Aanaminun ataminun-llu tangvaguarturtelluku.",
        "translation": "And they'd let them imaging their mother and father were watching them."
    },
    "141": {
        "startTime": 1181.217,
        "endTime": 1189.877,
        "transcript": "Tuaten tua-i ayuqluni tauna imna aipangqatallemni inerquuteka.",
        "translation": "That was what my admonishment was like when I was going to get married."
    },
    "142": {
        "startTime": 1190.742,
        "endTime": 1202.533,
        "transcript": "Calligtaarpek'nii-llu. Nutaan-llu mikelngurmek tangerqarraarlua, nutaan tuaten nutaan qanruyutet amllerrluteng.",
        "translation": "And I shouldn't go to various places. And when I first saw a child, now there was a lot of traditional wisdom."
    },
    "143": {
        "startTime": 1202.542,
        "endTime": 1215.762,
        "transcript": "Mat'um tau͡gken nalliini tuar imkut aipangelriit wall' irniangelriit, nutaan tuar imkut cat umyugiuqapiarluteng.",
        "translation": "These days, however, those who get married or have children, it seems that they do whatever they want."
    },
    "144": {
        "startTime": 1217.974,
        "endTime": 1220.844,
        "transcript": "Umyugiuqapiarluteng.",
        "translation": "They do whatever they want."
    },
    "145": {
        "startTime": 1220.85,
        "endTime": 1231.02,
        "transcript": "Tua-ll' angun kinguqvaarni kinguqliq aipanguq. Tua-i-ll' cali tuaten qalarulluku.",
        "translation": "Then a man gets married later. Then they also instruct him like that."
    },
    "146": {
        "startTime": 1231.337,
        "endTime": 1237.027,
        "transcript": "Aipaqa tauna pileryagavkenaku wiinga pisqellua.",
        "translation": "They told me not to treat my spouse harshly."
    },
    "147": {
        "startTime": 1237.418,
        "endTime": 1245.838,
        "transcript": "Qanemnek-llu piksaunaku, kiuleraksaunaku-llu waten pileryagqanga.",
        "translation": "And do not use my mouth against him, and don't reply harshly when he treats me harshly."
    },
    "148": {
        "startTime": 1246.065,
        "endTime": 1256.985,
        "transcript": "Tua-ll' im' angun tauna kinguqliq aipangan cali qanrutnauraat nutaan.",
        "translation": "Then when that last man gets married, they'd also instruct him."
    },
    "149": {
        "startTime": 1258.163,
        "endTime": 1262.793,
        "transcript": "Aipaa tauna uitanqegcivkarluku pisqelluku.",
        "translation": "They'd tell him to make sure his spouse is in peace."
    },
    "150": {
        "startTime": 1262.991,
        "endTime": 1267.341,
        "transcript": "Qennguaryaaqvigminek-llu taqciqniluku.",
        "translation": "And to say that he will stop after being upset."
    },
    "151": {
        "startTime": 1267.358,
        "endTime": 1269.228,
        "transcript": "Kitak' uitaqacuaqaqaa.",
        "translation": "Please wait a short minute."
    },
    "152": {
        "startTime": 1269.238,
        "endTime": 1270.178,
        "transcript": "Yaa.",
        "translation": "Okay."
    },
    "153": {
        "startTime": 1271.33,
        "endTime": 1273.76,
        "transcript": "Kan'a wani cimiqatartuq.",
        "translation": "That down there is going to be replaced."
    }
};